import { render } from "./ArtifactSetSelect.vue?vue&type=template&id=91b28a50&scoped=true&ts=true"
import script from "./ArtifactSetSelect.vue?vue&type=script&lang=ts"
export * from "./ArtifactSetSelect.vue?vue&type=script&lang=ts"

import "./ArtifactSetSelect.vue?vue&type=style&index=0&id=91b28a50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b28a50"]])

export default __exports__